import '@babel/polyfill';
import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';
import { StateInspector } from 'reinspect';
import ThemeProvider from '@material-ui/styles/ThemeProvider';
import { ThemeProvider as StyledProvider } from 'styled-components';
import { SnackbarProvider } from 'notistack';
import { IntlProvider } from 'react-intl';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers';
import store from '@/Store';
import theme from 'UIKit/Theme';
import languages from '@/utils/languages';
import Routes from './Routes';
import 'normalize.css';
import './main.scss';
import Init from './Init';
import { darkTheme } from './theme';
import Fallback from './components/Fallback';

Sentry.init({
  dsn:
    'https://7319beecbb5742b38fafb13e2d7ca5be@o228713.ingest.sentry.io/1385041',
});

const App = () => (
  <Sentry.ErrorBoundary fallback={Fallback} showDialog>
    <Provider store={store}>
      <IntlProvider
        textComponent={Fragment}
        locale="en"
        messages={languages.en}
      >
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="en">
          <ThemeProvider theme={darkTheme}>
            <StyledProvider theme={theme}>
              <SnackbarProvider autoHideDuration={3000} maxSnack={5}>
                <StateInspector name="App">
                  <Init />
                  <Routes />
                </StateInspector>
              </SnackbarProvider>
            </StyledProvider>
          </ThemeProvider>
        </LocalizationProvider>
      </IntlProvider>
    </Provider>
  </Sentry.ErrorBoundary>
);

ReactDOM.render(<App />, document.querySelector('#root'));
